module.exports = __webpack_public_path__ + "static/media/1989_GDP_totalRate.8e95035c.png";